var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAvaliation1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.9999 14.4444C25.9084 14.4444 14.4443 25.9086 14.4443 40C14.4443 54.0913 25.9084 65.5556 39.9999 65.5556C54.0912 65.5556 65.5555 54.0913 65.5555 40C65.5555 25.9086 54.0912 14.4444 39.9999 14.4444Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5217 47.2609H49.4782",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8477 33.9565C32.8477 35.7934 31.3568 37.2826 29.5216 37.2826C27.6864 37.2826 26.1956 35.7933 26.1956 33.9565C26.1956 32.1214 27.6864 30.6304 29.5216 30.6304C31.3568 30.6304 32.8477 32.1214 32.8477 33.9565Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.8043 33.9565C52.8043 35.7934 51.3134 37.2826 49.4782 37.2826C47.643 37.2826 46.1521 35.7933 46.1521 33.9565C46.1521 32.1214 47.643 30.6304 49.4782 30.6304C51.3134 30.6304 52.8043 32.1214 52.8043 33.9565Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvaliation1);
export default __webpack_public_path__ + "static/media/avaliation-1.84d744ad476a4093425c4275f316378a.svg";
export { ForwardRef as ReactComponent };